import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { DefaultLoader } from '#components/default-loader.tsx'
import { KnowledgeListPage } from '#features/knowledge/knowledge-list-page.tsx'

const searchSchema = z.object({
  type: z
    .enum(['decision', 'bugfix', 'feature', 'refactor', 'discovery', 'change'])
    .catch(undefined as never)
    .optional(),
  query: z.string().catch('').optional(),
})

export const Route = createFileRoute('/_app/$workspace/_dashboard/knowledge/')({
  component: KnowledgeListPage,
  pendingComponent: DefaultLoader,
  validateSearch: searchSchema,
})
